import React from "react";
import { Modal } from "antd";
import { ReactComponent as Loader } from "../icons/preloader.svg";

interface Props {
  visible: boolean;
  text?: string;
}

const WholeScreenModal: React.FC<Props> = ({ visible, text }) => {
  return (
    <Modal
      visible={visible}
      centered
      footer={null}
      closable={false}
      bodyStyle={{ textAlign: "center" }}
      maskStyle={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
    >
      <div className="my-5 py-5 text-center flex justify-content-center items-center">
        <Loader width={"128px"} height={'auto'}></Loader>
      </div>
      
      <div className="text-center my-2">
        <p>{text}</p>
      </div>

    </Modal>
  );
};

export default WholeScreenModal;
